var _circle, _circle2, _circle3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 120,
    viewBox: "0 0 156 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2379,
    cy: 35.0946,
    r: 31.1979,
    fill: "#EDF0F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2379,
    cy: 35.2379,
    r: 34.9844,
    stroke: "url(#paint0_linear)",
    strokeWidth: 0.50702
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.456,
    cy: 66.3302,
    r: 53.301,
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 35.2379,
    y1: 70.4801,
    x2: 35.2379,
    y2: 0.00124346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#BAD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1293,
    stopColor: "#A0CD49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#8DC756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3701,
    stopColor: "#82C45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7EC360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 102.445,
    y1: 119.63,
    x2: 102.445,
    y2: 13.0317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B9DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#672D8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircles);
export default __webpack_public_path__ + "static/media/BlueCircles.25d00b4698888d933317bdd47ae68b2d.svg";
export { ForwardRef as ReactComponent };